import { Observable } from 'rxjs';
import { share } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UrlQueryDef } from '../_appCommon/base/UrlQueryDef';
import { EntityConfig } from '../_appCommon/base/EntityConfig';
import { EntityDataServiceBase } from '../_appCommon/base/EntityDataServiceBase';

@Injectable()
export class DentalMonitoringDataService extends EntityDataServiceBase
{
  constructor(protected http: HttpClient)
  {
    super(http, 'DentalMonitoring');
  }

  protected loadEntityConfig(): void
  {
    this.entityConfig = new EntityConfig();
    this.entityConfig.entityDisplayName = 'DentalMonitoring';
    this.entityConfig.apiUrl = 'api/DentalMonitoring';
  }

  public getSmartStlOrders(queryDef: UrlQueryDef): Observable<any>
  {
    let observable = this.http.get(this.createUrl('GetSmartStlOrders'), queryDef.getRequestConfig(false)).pipe(share());
    return observable;
  }

  public getDentalMonitoringPatientInfo(profileId: string): Observable<any>
  {
    let queryDef = new UrlQueryDef();
    let observable = this.http.get(this.createUrl('getPatient/'+profileId), queryDef.getRequestConfig(false)).pipe(share());
    return observable;
  }

  public createDentalMonitoringSmartStlOrder(body: any): Observable<any>{
    let queryDef = new UrlQueryDef();
    let observable = this.http.post(this.createUrl('createSmartStlOrder'), body, queryDef.getRequestConfig(true)).pipe(share());
    this._handleObservableResponse(observable);
    return observable;
  }

  public cancelDentalMonitoringSmartStlRequest(body: any): Observable<any>{
    let queryDef = new UrlQueryDef();
    let observable = this.http.post(this.createUrl('deleteSmartStlOrder'), body, queryDef.getRequestConfig(true)).pipe(share());
    this._handleObservableResponse(observable);
    return observable;
  }

  public downloadStlFile(queryDef: UrlQueryDef): Observable<{}> {
    const config = {...queryDef.getRequestConfig(false), responseType: 'blob'}

    const observable = this.http.get(this.createUrl('downloadStlFile'),  config).pipe(share());

    this._handleObservableResponse(observable);

    return observable;
  }
  
}
